import request from '@/utils/request.js'
import request_conv from '@/utils/request_conv.js'
import request_ad from '@/utils/request_ad.js'
/***  封装请求方法  ***/
export function wxRequest(url, data, method){
    let obj = {};
    if(method=="get"){
        obj = {
            url: url,
            method: method,
            params: data,
        }
    }else if(method=="post"){
        obj = {
            url,
            method,
            data,
        }
    }
    return request(obj)
}

/**第三方地址***/

export function convRequest(url, data, method){
    let obj = {};
    if(method=="get"){
        obj = {
            url: url,
            method: method,
            params: data,
        }
    }else if(method=="post"){
        obj = {
            url,
            method,
            data,
        }
    }
    return request_conv(obj)
}

export function adRequest(url, data, method){
    let obj = {};
    if(method=="get"){
        obj = {
            url: url,
            method: method,
            params: data,
        }
    }else if(method=="post"){
        obj = {
            url,
            method,
            data,
        }
    }
    return request_ad(obj)
}

/***实名认证***/
export function verified(params){

    var formdata = new FormData();
    Object.keys(params).forEach((key) => {
        formdata.append(key, params[key]);
    });
    return request({
        url: 'wxAuth/insert',
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: formdata
    })
}

